function CardTeam(props) {

    return (
        <div
            className={`
                    flex flex-col bg-light mt-8
                    md:mt-0
                    md:w-48
                    lg:w-80
                    xl:
                    2xl:w-96
            `}
            style={{
                boxShadow: `${props.shadowX || 0}px ${props.shadowY || 12}px 30px rgba(0, 0, 0, 0.2)`,
            }}
        >
            <div className="w-full overflow-hidden">
                <img
                    src={props.image}
                    alt={props.name}
                    className="object-cover w-full h-full border-light border-[16px]"
                />
            </div>
            <div className="
                    bg-light text-black text-center font-bold py-[1vw] text-[4vw]
                    sm:text-[4vw]
                    md:text-[2vw]
                    xl:text-[2vw]
                    2xl:text-[1.8vw]
                    3xl:text-[1.5vw]
            ">
                {props.name}
            </div>
        </div>
    );
}

export default CardTeam;
